var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/**
 * Um tema no menu do nome - ver `domain/panel-theme.ts`.
 *
 * O `value` e o mesmo nome que o renderizador poe na raiz da pagina, e a miniatura
 * de cada opcao e desenhada por ele a partir disso.
 */
let ThemeOptionScope = class ThemeOptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.value = 'PRAIA';
        this.label = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", String)
], ThemeOptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ThemeOptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ThemeOptionScope.prototype, "current", void 0);
ThemeOptionScope = __decorate([
    Observable
], ThemeOptionScope);
export { ThemeOptionScope };
let NavItemScope = class NavItemScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.icon = '';
        this.current = false;
        this.group = 'main';
        /**
         * O endereco do item, para ele ser um `<a>` de verdade.
         *
         * O painel antigo envolve cada item num `<Link>`, e isso NAO e enfeite: dentro
         * de um container flex quem tem de ser o item flex e o elo, senao o `display`
         * do filho blockifica e a margem do `space-y-*` troca de elemento. Alem disso,
         * um item de menu que nao da para abrir em outra aba e um item pior.
         *
         * Vazio no "Sair", que nao leva a lugar nenhum - la tambem ele nao e um `<a>`.
         */
        this.href = '';
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], NavItemScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], NavItemScope.prototype, "icon", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], NavItemScope.prototype, "current", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], NavItemScope.prototype, "group", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], NavItemScope.prototype, "href", void 0);
__decorate([
    observe(),
    __metadata("design:type", Number)
], NavItemScope.prototype, "notification", void 0);
NavItemScope = __decorate([
    Observable
], NavItemScope);
export { NavItemScope };
/**
 * Um grupo do menu, com o nome que aparece acima dos itens.
 *
 * Espelha o `GroupProps` do painel antigo: "PRINCIPAL" com as telas de trabalho e
 * "SISTEMA" com conta e saida. O nome e texto de PRODUTO, e por isso mora no
 * scope - a view desenha o que lhe dao.
 */
let NavGroupScope = class NavGroupScope extends Scope {
    constructor() {
        super(...arguments);
        this.name = '';
        this.items = [];
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], NavGroupScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], NavGroupScope.prototype, "items", void 0);
NavGroupScope = __decorate([
    Observable
], NavGroupScope);
export { NavGroupScope };
/**
 * O HUB: menu lateral e o corpo da tela que estiver dentro.
 *
 * `content` e um slot como o `body` do shell. A diferenca e o que envolve cada
 * um: o shell envolve a aplicacao inteira, incluindo a porta; este envolve so o
 * que exige sessao, e por isso pode desenhar menu.
 */
let RestrictedScope = class RestrictedScope extends Scope {
    constructor() {
        super(...arguments);
        this.navigation = [];
        this.sectionTitle = '';
        /**
         * Ligado enquanto o nome de quem esta logado nao chegou.
         *
         * O painel antigo desenha um `mdiLoading` girando nesse intervalo, e nao o
         * e-mail: o nome vem de `/v2/professionals/me` ou `/v2/companies/current`, que e
         * outra requisicao depois da sessao.
         */
        this.identityLoading = false;
        /**
         * O menu do NOME, no canto do cabecalho (decisao de 08/10/2026).
         *
         * A aparencia mora ali, a um clique de qualquer tela, junto de "Meus dados" e
         * "Sair". A escolha de empresa continua na linha de baixo do nome: ela tem busca
         * e paginacao para o administrador geral, e nao cabe num menu.
         */
        this.themes = [];
        this.onOpenMyData = Scope.ASYNC_ACTION;
        this.onSignOut = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Array)
], RestrictedScope.prototype, "navigation", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], RestrictedScope.prototype, "sectionTitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], RestrictedScope.prototype, "sectionSubtitle", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], RestrictedScope.prototype, "sectionIcon", void 0);
__decorate([
    observe(),
    __metadata("design:type", Scope
    /** Quem esta logado. O painel antigo mostra os dois no topo de toda tela. */
    )
], RestrictedScope.prototype, "content", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], RestrictedScope.prototype, "userName", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], RestrictedScope.prototype, "roleLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Function)
], RestrictedScope.prototype, "companySelector", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], RestrictedScope.prototype, "identityLoading", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], RestrictedScope.prototype, "themes", void 0);
RestrictedScope = __decorate([
    Observable
], RestrictedScope);
export { RestrictedScope };
//# sourceMappingURL=restricted.scope.js.map